export default {
  common: {
    actions: 'Aktionen',
    apply: 'Übernehmen',
    filter: 'Filter',
    filters: 'Filter',
    reset_filter: 'Filter zurücksetzen',
    new: 'Neu',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    deleting: 'Wird gelöscht...',
    cancel: 'Abbrechen',
    abbrechen: 'Abbrechen',
    reset: 'Zurücksetzen',
    save: 'Speichern',
    saving: 'Wird gespeichert...',
    create: 'Erstellen',
    loading: 'Wird geladen...',
    download: 'Download',
    wait: 'Bitte warten...',
    yes: 'Ja',
    no: 'Nein',
    none: '(kein Wert)',
    noResults: 'Keine Ergebnisse.',
    itemsPerPage: 'Einträge pro Seite',
    searchPlaceholder: 'Nach {field} suchen...',
    searchNr: 'Nach Nummer suchen...',
    searchName: 'Nach Name suchen...',
    sessionEnd: 'Sitzungsende in',
    search: 'Suche',
    expand: 'Ausklappen',
    collapse: 'Einklappen',
    expand_sidebar: 'Sidebar ausklappen',
    collapse_sidebar: 'Sidebar einklappen',
    logout: 'Ausloggen',
    id: 'ID',
    close: 'Schließen',
    confirm: 'Bestätigen',
    columns: 'Spalten',
    back: 'Zurück',
    general: 'Allgemein',
    logo_full: 'CEETRAC Logo',
    logo_icon: 'CEETRAC Icon',
    link1: 'Link 1',
    link2: 'Link 2',
    link3: 'Link 3',
    selectDate: 'Datum auswählen',
    verknuepfen: 'Verknüpfen',
    alleVerknuepfen: 'Alle verknüpfen',
    zurueck: 'Zurück',
    weiter: 'Weiter',
    gesamt: 'Gesamt',
    nachweise: 'Nachweise',
    remove: 'Entfernen',
    assign: 'Übernehmen',
    select: 'Bitte auswählen',
    nr: 'Nr',
    name: 'Name',
    darkMode: 'Dunkelmodus aktivieren',
    lightMode: 'Hellmodus aktivieren',
    detail: 'Details',
    date: 'Datum',
    datum: 'Datum',
    amount: 'Menge',
    unit: 'Einheit',
    refresh: 'Aktualisieren',
    noData: 'Keine Daten vorhanden.',
    noPreview: 'Keine Vorschau vorhanden.',
    entries: 'Einträge',
    selectPartner: 'Kunde auswählen',
    selectProdukt: 'Produkt auswählen',
    unsaved_changes: 'Ungespeicherte Änderungen',
    unsaved_changes_message:
      'Sie haben ungespeicherte Änderungen. Möchten Sie wirklich fortfahren ohne zu speichern?',
    discard: 'Verwerfen',
    standort: 'Standort',
    produkt: 'Produkt',
    volumen: 'Volumen',
    fuellstand: 'Füllstand',
    delete_warning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    no_permissions: 'Keine Berechtigungen',
    no_permissions_message: 'Sie haben nicht die benötigten Rechte für diese Aktion.',
    ceemas: 'Zu CEEMAS',
    totals: 'Gesamt',
    sumsTotal: 'Summe: Gesamt',
    sumsByPage: 'Summe: pro Seite',
    excelDownloadSuccess: 'Excel-Dokument erfolgreich heruntergeladen.',
    excelDownloadError: 'Fehler beim Herunterladen des Excel-Dokuments.',
    recipient: 'Empfänger',
    cc: 'Cc',
    send: 'Senden',
    nextMonth: 'Nächster Monat',
    nextYear: 'Nächstes Jahr',
    previousMonth: 'Letzter Monat',
    previousYear: 'Letztes Jahr',
    required: 'Pflichfeld',
    loadMore: 'Mehr laden',
    fieldConfig: {
      selectColumnsFor: 'Tabellenspalten auswählen für',
      listConfig: 'Spaltenkonfiguration',
      clickToDelete: 'Klicken zum Löschen',
      delete: 'Löschen',
      deleteListConfigExplanation:
        'Hinweis: Zum Löschen einer Konfiguration muss im Anschluss `Speichern` geklickt werden.',
      name: 'Name',
      noSelectedPropertiesExplanation: 'Keine Spalten ausgewählt.',
      selectedProperties: 'Ausgewählte Spalten:',
      dragToReorder: 'Zum Neuordnen ziehen',
      availableProperties: 'Verfügbare Spalten:',
      createNew: 'Neue erstellen',
      deleteListConfigNotification: 'Konfiguration gelöscht',
      saved: 'Konfiguration gespeichert'
    }
  },
  register: {
    username: 'Benutzername',
    firstName: 'Vorname',
    lastName: 'Nachname',
    password: 'Passwort',
    password2: 'Passwort wiederholen',
    register: 'Registrieren',
    terms: 'Allgemeine Geschäftsbedingungen',
    street: 'Straße',
    houseNr: 'Hausnummer',
    city: 'Stadt',
    zipCode: 'Postleitzahl',
    country: 'Land',
    messages: {
      success: 'Registrierung war erfolgreich.',
      notFound: 'Einladung nicht gefunden.',
      pwdMismatch: 'Passwörter stimmen nicht überein.'
    }
  },
  auth: {
    login: 'Anmelden',
    logout: 'Abmelden',
    username: 'Benutzername',
    password: 'Passwort',
    reset_pwd: 'Passwort ändern',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort wiederholen',
    forgot_password: 'Passwort vergessen?',
    login_error: 'Anmeldung fehlgeschlagen',
    two_factor_authentication: '2-Faktor-Authentifizierung',
    enter_code: 'Bitte geben Sie den Code aus Ihrer Authenticator-App ein.',
    enter_credentials: 'Bitte geben Sie Ihre Anmeldedaten ein.',
    enter_password: 'Sie müssen Ihr Passwort ändern.',
    scan_qr_code:
      'Scannen Sie diesen QR-Code mit Ihrer Authenticator-App (z.B. Google Authenticator oder Microsoft Authenticator)',
    authentication_code: 'Authentifizierungscode',
    enter_code_from_app: 'Bitte geben Sie den Code aus Ihrer Authenticator-App ein.',
    verify: 'Verifizieren',
    verifying: 'Wird verifiziert...',
    tenant_selection: 'Mandantenauswahl',
    select_tenant: 'Wählen Sie den Mandanten aus, mit dem Sie arbeiten möchten',
    search_tenants: 'Mandanten durchsuchen...',
    of: 'von',
    found: 'gefunden',
    available: 'verfügbar',
    last_used: 'Zuletzt verwendet',
    last_used_short: 'Zuletzt verwendet',
    administrator: 'Administrator',
    more_tenants: 'Weitere Mandanten',
    available_tenants: 'Verfügbare Mandanten',
    no_tenants_found: 'Keine Mandanten gefunden',
    check_search_input: 'Bitte überprüfen Sie Ihre Sucheingabe',
    select_and_continue: 'Auswählen und fortfahren',
    maintenance_error: 'Wartungsfenster aktiv. Anmeldung derzeit nicht möglich.'
  },
  navigation: {
    home: 'Startseite',
    settings: 'Einstellungen',
    stammdaten: 'Stammdaten',
    bewegungsdaten: 'Bewegungsdaten',
    reports: 'Auswertungen',
    layouts: 'Layouts',
    help: 'Hilfe / FAQ',
    user: 'Benutzer',
    bewegungsdaten_children: {
      einlieferungen: 'Einlieferungen',
      ablieferungen: 'Ablieferungen',
      abholungen: 'Abholungen',
      bestaende: 'Bestände',
      nachweisbescheinigungen: 'Nachweisbescheinigungen',
      tankstelle_bestand: 'Übersicht Tankstelle',
      nachweisverfolgung: 'Übersicht Nachweisverfolgung',
      zertifikate: 'Nachweise',
      bilanzen: 'PoC Verteilung',
      pocs: 'PoCs',
      import: 'Datenimport',
      nachweisverteilung: 'Nachweisverteilung'
    },
    stammdaten_children: {
      allgemein: 'Allgemein',
      partner: 'Partner',
      standorte: 'Standorte',
      produkte: 'Produkte',
      zertifizierungen: 'Zertifizierungen',
      import: 'Datenimport'
    },
    reports_children: {
      liste: 'Berichte',
      auswertungen: 'Auswertungen',
      logmeldungen: 'Logmeldungen',
      ytdOverview: 'YTD Übersicht'
    },
    layouts_children: {
      about: 'Über uns',
      accordion: 'Akkordeon',
      badge: 'Abzeichen',
      breadcrumb: 'Brotkrumen',
      button_group: 'Button Gruppe',
      button_icons: 'Button Icons',
      buttons: 'Buttons',
      data_display: 'Datenanzeige',
      date_picker: 'Datumsauswahl',
      input: 'Eingabe',
      pagination: 'Seitennummerierung',
      sidebar: 'Seitenleiste',
      table: 'Tabelle',
      tabs_group: 'Tabs Gruppe'
    },
    help_children: {
      documentation: 'Dokumentation',
      faq: 'FAQ',
      videos: 'Hilfevideos'
    },
    user_children: {
      change_password: 'Passwort wechseln',
      '2fa_reset': '2FA Reset',
      settings: 'Einstellungen',
      permissions: 'Berechtigungen',
      messages: 'Nachrichten',
      administration: 'Benutzeradministration',
      permission_management: 'Berechtigungsverwaltung',
      mandanten: 'Mandantenverwaltung',
      roles: 'Rollen',
      release_notes: 'Release Notes',
      dashboard: 'Dashboard'
    },
    import: 'Import'
  },
  settings: {
    title: 'Einstellungen',
    description: 'Passen Sie die Anwendung an Ihre Bedürfnisse an',
    language: 'Sprache',
    german: 'Deutsch',
    english: 'Englisch',
    compactMode: 'Kompakter Modus',
    compactModeDescription: 'Reduzierte Abstände für mehr Inhalt',
    theme: 'Design',
    privacy: 'Datenschutz',
    personal: {
      title: 'Persönliche Einstellungen',
      description: 'Passen Sie die grundlegenden Einstellungen an Ihre Bedürfnisse an',
      timezone: 'Zeitzone',
      dateFormat: 'Datumsformat',
      itemsPerPage: 'Einträge pro Seite',
      entries: 'Einträge'
    },
    notifications: {
      title: 'Benachrichtigungen',
      description: 'Verwalten Sie Ihre Benachrichtigungseinstellungen',
      email: {
        title: 'E-Mail',
        description: 'Erhalten Sie wichtige Updates per E-Mail'
      },
      browser: {
        title: 'Browser',
        description: 'Desktop-Benachrichtigungen im Browser'
      }
    },
    display: {
      title: 'Darstellung',
      description: 'Passen Sie das Erscheinungsbild an',
      compactMode: {
        title: 'Kompakter Modus',
        description: 'Reduzierte Abstände für mehr Inhalt'
      }
    },
    timezones: {
      berlin: 'Berlin (UTC+1)',
      london: 'London (UTC)',
      newYork: 'New York (UTC-5)'
    },
    dateFormats: {
      german: '31.12.2023',
      iso: '2023-12-31',
      us: '12/31/2023'
    },
    buttons: {
      save: 'Speichern',
      saving: 'Wird gespeichert...'
    },
    messages: {
      saveSuccess: 'Einstellungen wurden erfolgreich gespeichert',
      loadError: 'Fehler beim Laden der Einstellungen',
      saveError: 'Ein unerwarteter Fehler ist aufgetreten'
    },
    tenant: {
      title: 'Mandantenauswahl',
      description: 'Wählen Sie den aktiven Mandanten aus.',
      select: 'Aktiver Mandant',
      changed: 'Mandant erfolgreich gewechselt',
      error: 'Der Mandant konnte nicht gewechselt werden'
    }
  },
  permissions: {
    title: 'Berechtigungen',
    description: 'Übersicht über Ihre Berechtigungen',
    errors: {
      loadRoles: 'Rollen konnten nicht geladen werden.',
      loadUsers: 'Benutzer konnten nicht geladen werden.',
      loadPermissions: 'Berechtigungen konnten nicht geladen werden.'
    },
    roles: {
      title: 'Zugewiesene Rollen',
      description: 'Rollen, die Ihnen zugewiesen sind',
      assigned: 'Zugewiesen',
      notAssigned: 'Nicht zugewiesen'
    },
    locations: {
      title: 'Zugewiesene Standorte',
      description: 'Standorte, auf die Sie berechtigt sind',
      allLocations: '(alle Standorte)'
    },
    management: {
      title: 'Berechtigungverwaltung',
      description: 'Verwalten Sie Berechtigungen für Benutzer',
      userSelection: 'Benutzerauswahl',
      userSelectionDescription:
        'Wählen Sie einen nicht-administrativen Benutzer aus, um dessen Berechtigungen zu verwalten.',
      selectUser: 'Benutzer auswählen',
      chooseUser: 'Benutzer wählen...',
      userInfo: 'Benutzerinformationen',
      standort: 'Standort',
      allLocations: '(alle Standorte)',
      addStandort: 'Standort hinzufügen',
      permissions: 'Berechtigungen',
      permissionsDescription: 'Verwalten Sie Benutzer-Berechtigungen',
      canRead: 'Anzeigen',
      canWrite: 'Bearbeiten',
      noUserSelected: 'Kein Benutzer ausgewählt',
      saveSuccess: 'Berechtigungen wurden erfolgreich gespeichert.',
      saveError: 'Fehler beim Speichern der Berechtigungen.',
      categories: {
        standorte: 'Standorte',
        stammdaten: 'Stammdaten',
        bewegungsdaten: 'Bewegungsdaten',
        nachweiseUndBerichte: 'Nachweisbescheinigungen & Berichte'
      },
      roles: {
        produkte: 'Produkte',
        standorte: 'Standorte',
        partner: 'Partner',
        abholungen: 'Abholungen',
        einlieferungen: 'Einlieferungen',
        ablieferungen: 'Ablieferungen',
        bestaende: 'Bestände',
        nachweise: 'Nachweisbescheinigungen',
        nachweisverfolgung: 'Nachweisverfolgung',
        berichte: 'Berichte',
        cockpit: 'Übersicht Tankstelle',
        zertifikate: 'Nachweise',
        bilanzen: 'PoC-Verteilungen',
        poc: 'PoCs',
        ytdberichte: 'YTD Bericht'
      }
    }
  },
  views: {
    allgemein: {
      mandant: {
        title: 'Mandant',
        description: 'Passen Sie die Stammdaten des Mandanten an.',
        identifier: 'Identifier',
        name: 'Name',
        strasse: 'Straße',
        hausNr: 'Haus-Nr',
        plz: 'PLZ',
        stadt: 'Stadt',
        land: 'Land',
        email: 'E-Mail'
      }
    },
    pocs: {
      title: 'PoCs',
      noData: 'Keine PoCs vorhanden.',
      download: 'PoC herunterladen',
      downloadXml: 'XML herunterladen',
      messages: {
        patchSuccess: 'PoC wurde neu erstellt.',
        patchError: 'PoC konnte aufgrund eines Fehlers nicht neu erstellt werden.'
      },
      patchTitle: 'PoC neu erstellen',
      patchConfirm: 'Soll das Dokument tatsächlich neu erstellt werden?',
      filter: {
        title: 'Filter',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        standort: 'Standort',
        produkt: 'Produkt',
        partner: 'Empfänger/Kunde',
        zeitraum: 'Zeitraum',
        allProducts: '(alle Produkte)',
        allStandorte: '(alle Standorte)',
        allPartners: '(alle Empfänger/Kunden)'
      },
      columns: {
        id: 'ID',
        draft: 'Draft',
        mandantLand: 'Land',
        mandantName: 'Lieferant Name',
        standortCode: 'Flughafen Code',
        standort: 'Standort Name',
        jahr: 'Jahr',
        produkt: 'Produkt Name',
        partner: 'Empfänger Name',
        zeitraum: 'Zeitraum',
        nummer: 'Unique Number PoC',
        ausstellungsdatum: 'Date Issuance PoC',
        versanddatum: 'Zeitraum',
        deliveryNoteNr: 'Delivery Note Number',
        nachweisNr: 'Unique Number PoS',
        scheme: 'Scheme',
        supplier: 'Supplier Name',
        supplierAddress: 'Supplier Adress',
        supplierNachweisNr: 'Supplier Certificate Number',
        recipient: 'Recipient Name',
        recipientAddress: 'Recipient Adress',
        recipientContractNr: 'Recipient Contract Number',
        ausgangsstelle: 'Address of dispatch',
        lieferstelle: 'Address of receiving point',
        dateDispatch: 'Date of dispatch',
        ausgangsstelleGleichSupplier: 'Same as address of supplier',
        feedstock: 'Feedstock',
        additionalInformation: 'Additional Info',
        origin: 'Country of Origin',
        biomenge: 'Quantity (Bio)',
        biomasseArt: 'Product',
        gesamtMenge: 'Total quantity product',
        energy: 'Energy content',
        lcv: 'LCV',
        dichte: 'Product density',
        euRedCompliant: 'EU RED III Compliant',
        redSustainableCultivation: 'Red Sustainable Cultivation',
        redWasteFlag: 'Red waste flag',
        totalDefaultValueAccToRed: 'Total default value according to RED III applied',
        ghgEmissionEc: 'Eec',
        ghgEmissionLanduse: 'El',
        ghgEmissionProcessed: 'Ep',
        ghgEmissionTd: 'Etd',
        ghgEmissionU: 'Eu',
        ghgEmissionSca: 'Esca',
        ghgEmissionCcs: 'Eccs',
        ghgEmissionCcr: 'Eccr',
        e: 'E',
        allocatedHeat: 'Allocated heat',
        allocatedElectricity: 'Allocated electricity',
        savingsFuelsTransport: 'Biofuels for transport',
        savingsLiquidsElectricity: 'Biomass fuels for the production of electricity',
        savingsFuelsElectricity: 'Bioliquids for electricity',
        savingsLiquidsHeatProduction: 'Savings fules heat production',
        savingsFuelsHeatProduction: 'Savings liquids head production',
        savingsFuelsCoalHeatProduction: 'Savings fules coal head production'
      }
    },
    bilanzen: {
      title: 'PoC Verteilung',
      createTitle: 'Verteilung erstellen',
      createConflict:
        'Es gibt eine offene Verteilung, die abgeschlossen werden muss, bevor eine neue erstellt werden kann.',
      editTitle: 'Verteilung bearbeiten',
      unlockTitle: 'Verteilung zurücksetzen',
      unlockConfirm: 'Sind Sie sicher, dass Sie diese Verteilung zurücksetzen möchten?',
      deleteTitle: 'Verteilung löschen',
      deleteConfirm: 'Sind Sie sicher, dass Sie diese Verteilung löschen möchten?',
      closeTitle: 'Verteilung abschließen',
      closeConfirm:
        'Sind Sie sicher, dass Sie diese Verteilung abschließen möchten? Änderungen sind dann nicht mehr möglich.',
      sendTitle: 'PoCs verschicken',
      sendText:
        'Hiermit wird ein Massenversand der vorhandenen PoCs angestoßen. Sie können E-Mail-Adressen angeben, die jeweils Kopien der Nachrichten bekommen sollen. Mehrere Empfänger können durch Semikolon getrennt werden.',
      sendPosTitle: 'PoCs verschicken',
      sendPosText:
        'Geben Sie einen oder mehrere Empfänger an. Vorausgefüllt sind E-Mail-Adressen aus den Stammdaten des Kunden. Mehrere Empfänger können durch Semikolon getrennt werden.',
      sftpSendTitle: 'Versand per sFTP',
      sftpSendConfirm: 'Möchten Sie den sFTP-Upload starten?',
      closePosTitle: 'Position abschließen',
      closePosConfirm:
        'Sind Sie sicher, dass Sie diese Position abschließen möchten? Änderungen sind dann nicht mehr möglich.',
      lockTitle: 'Verteilung sperren',
      lockText:
        'Nachdem die Verteilung gesperrt wurde, werden Nachweise für den entsprechenden Zeitraum erstellt.',
      lockConfirm: 'Sind Sie sicher, dass Sie diese Verteilung sperren möchten?',
      lockPosTitle: 'Position sperren',
      lockPosText:
        'Nachdem die Position gesperrt wurde, werden Nachweise für den entsprechenden Zeitraum erstellt.',
      lockPosConfirm: 'Sind Sie sicher, dass Sie diese Position sperren möchten?',
      unlockPosTitle: 'Position zurücksetzen',
      unlockPosConfirm: 'Sind Sie sicher, dass Sie diese Position zurücksetzen möchten?',
      noData: 'Keine Verteilungen vorhanden.',
      invalidData:
        'Inkorrekte Daten. Bitte geben Sie die Priorität und einen validen Wert für Biomenge und/oder Biogehalt an.',
      lock: 'Sperren',
      unlock: 'Zurücksetzen',
      close: 'Abschließen',
      download: 'Nachweis herunterladen',
      send: 'Verschicken',
      recipient: 'Empfänger',
      cc: 'Cc',
      pdf: 'PDF im Anhang verschicken',
      xml: 'XML im Anhang verschicken',
      filter: {
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        standort: 'Standort',
        produkt: 'Produkt',
        allStandorte: '(alle Standorte)',
        allProducts: '(alle Produkte)'
      },
      status: {
        offen: 'offen',
        gesperrt: 'gesperrt',
        geschlossen: 'abgeschlossen'
      },
      messages: {
        bulkSent: 'Massenversand wurde erfolgreich angestoßen.',
        bulkSentError: 'Massenversand konnte nicht angestoßen werden.',
        sent: 'PoCs wurden erfolgreich verschickt.',
        sentError: 'PoCs konnten nicht verschickt werden.',
        sftpSent: 'sFTP-Upload war erfolgreich.',
        sftpError: 'sFTP-Upload ist fehlgeschlagen. {error}',
        biomengeOverflowError: 'Es wurde zu viel Biomenge verteilt, als verfügbar ist.',
        maxBeimischungOverflowError:
          'Es wurde mehr Biomenge zugewiesen, als erlaubt (max. {0}% Beimischung).'
      },
      columns: {
        standort: 'Standort',
        standortNr: 'Standort-Nr',
        standortCode: 'Standort-Code',
        produkt: 'Produkt',
        produktNr: 'Produkt-Nr',
        mandantName: 'Mandant',
        mandantLand: 'Mandant-Land',
        von: 'Von',
        bis: 'Bis',
        vonMonat: 'Von (Monat)',
        vonJahr: 'Von (Jahr)',
        bisMonat: 'Bis (Monat)',
        bisJahr: 'Bis (Jahr)',
        partner: 'Kunde',
        group: 'Gruppe',
        status: 'Status',
        statusCode: 'Status Code',
        zeitraum: 'Zeitraum',
        gesamt: 'Gesamt (L)',
        menge: 'Menge',
        gesamtBiomenge: 'Gesamt-Biomenge (L)',
        zusatzBiomenge: 'Zusatz-Menge',
        biogehalt: 'Biogehalt (%)',
        priority: 'Priorität',
        restBiomenge: 'Rest-Biomenge (L)',
        gesamtZugewiesen: 'Zugewiesen (L)',
        zugewiesen: 'Zugewiesen',
        pocMenge: 'PoC-Menge',
        nachweise: 'Nachweise',
        ytdPocMenge: 'YTD PoC-Menge',
        ytdSollMenge: 'YTD Soll-Menge',
        ytdDiffMenge: 'YTD Differenz',
        ytdZusatzMenge: 'YTD Zusatz-Menge',
        ytdPocTotalMenge: 'YTD PoC-Menge (alle Standorte)',
        ytdSollTotalMenge: 'YTD Soll-Menge (alle Standorte)',
        ytdDiffTotalMenge: 'YTD Differenz (alle Standorte)'
      },
      ansicht: {
        anzeige: 'Anzeige',
        kompakt: '(kompakt)',
        menge: 'Menge',
        zusatzBiomenge: 'Zusatz-Menge',
        pocMenge: 'PoC-Menge',
        ytdMenge: 'YTD-Menge'
      }
    },
    zertifikate: {
      title: 'Nachweise',
      editTitle: 'Nachweis bearbeiten',
      createTitle: 'Neuen Nachweis erstellen',
      deleteTitle: 'Nachweis löschen',
      deleteConfirm: 'Möchten Sie diesen Nachweis wirklich löschen?',
      download: 'Nachweis herunterladen',
      filter: {
        all: '(alle)',
        title: 'Filter',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        nr: 'Nr',
        land: 'Anbauland',
        rohstoff: 'Rohstoff',
        produkt: 'Produkt',
        lieferant: 'Lieferant',
        empfaenger: 'Empfänger',
        lieferstelle: 'Lieferstelle',
        zeitraum: 'Zeitraum'
      },
      status: {
        open: 'offen',
        locked: 'gesperrt',
        inProgress: 'in Bearbeitung',
        inDistribution: 'in Verteilung',
        completed: 'abgeschlossen',
        unknown: 'unbekannt'
      },
      abholungen: {
        title: 'Abholungen',
        add: 'Verknüpfen',
        clear: 'Alle entfernen',
        keineAbholungen: 'Keine Abholungen verfügbar.',
        abholungAuswaehlen: 'Abholung auswählen'
      },
      columns: {
        nr: 'Nr',
        status: 'Status',
        thg: 'E (gCO2eq/MJ)',
        nnwEnergie: 'Energiegehalt (MJ)',
        lcv: 'Unterer Heizwert (MJ/kg)',
        info: 'Zusatzinformation',
        waste: 'Rohstoff ist Abfall (ja/nein)',
        sustainable: 'Rohstoff aus nachhaltiger Landwirtschaft (ja/nein)',
        menge: 'Menge (m³ oder Tonne)',
        biomasseArt: 'Biomasse-Art',
        biomasseCode: 'Biomasse-Code',
        biogehalt: 'Biogehalt',
        anbauland: 'Anbauland',
        rohstoff: 'Rohstoff',
        produkt: 'Produkt',
        zertifizierungsystem: 'Zertifizierungsystem',
        ghgEmissionEc: 'Eec (gCO2eq/MJ)',
        ghgEmissionEl: 'El (gCO2eq/MJ)',
        ghgEmissionEp: 'Ep (gCO2eq/MJ)',
        ghgEmissionTd: 'Etd (gCO2eq/MJ)',
        ghgEmissionU: 'Eu (gCO2eq/MJ)',
        ghgEmissionEsca: 'Esca (gCO2eq/MJ)',
        ghgEmissionCcs: 'Eccs (gCO2eq/MJ)',
        ghgEmissionCcr: 'Eccr (gCO2eq/MJ)',
        allocatedHeat: 'Heizfaktor (gCO2eq/MJ)',
        allocatedElectricity: 'Stromfaktor (gCO2eq/MJ)',
        totalDefault: 'Gesamt-Default-Wert nach RED II? (ja/nein)',
        datum: 'Ausstellungsdatum',
        zeitraum: 'Zeitraum',
        referenzNachweisNr: 'Ursprungs-PoS-Nr',
        scheme: 'Compliance-System des Ursprungs-PoS',
        supplier: 'Lieferant',
        supplierNachweisNr: 'Nachweis-Nr des Lieferanten',
        recipient: 'Empfänger',
        recipientContractNr: 'Vertrags-Nr des Empfängers',
        ausgangsstelle: 'Ausgangsstelle',
        lieferstelle: 'Lieferstelle',
        lieferungVon: 'Lieferzeitraum (von)',
        lieferungBis: 'Lieferzeitraum (bis)',
        mengeGesamt: 'Gelieferte Menge (m³ oder Tonne)',
        dichte: 'Dichte (kg/m³)',
        euRed2Compliant: 'EU RED II konform',
        file: 'Datei',
        mandantName: 'Mandant',
        mandantLand: 'Mandant-Land',
        land: 'Länder-Code',
        landName: 'Anbauland (Name)',
        feedstockId: 'Rohstoff-ID',
        nnwProduktName: 'NNW-Produkt-Name',
        nnwProduktNr: 'NNW-Produkt-Nr',
        produktNr: 'Produkt-Nr',
        produktVersion: 'Produkt-Version',
        zertifizierungssystemId: 'Zertifizierungssystem-ID',
        supplierNr: 'Lieferant-Nr',
        recipientNr: 'Empfänger-Nr',
        recipientVersion: 'Empfänger-Version',
        ausgangsstelleGleichSupplier: 'Ausgangsstelle = Lieferant',
        lieferstelleNr: 'Lieferstelle-Nr',
        lieferstelleVersion: 'Lieferstelle-Version',
        standortCode: 'Standort-Code',
        ghgEmissionEe: 'Eee (gCO2eq/MJ)',
        ghgEmissionEscaBonusCap: 'Esca Bonus Cap (gCO2eq/MJ)'
      }
    },
    tauschpartner: {
      title: 'Partner',
      createTitle: 'Neuen Partner erstellen',
      editTitle: 'Tauschpartner bearbeiten',
      deleteTitle: 'Partner löschen',
      deleteConfirm: 'Sind Sie sicher, dass Sie diesen Partner löschen möchten?',
      confirmNrChange: 'Möchten Sie die Partner-Nummer wirklich ändern?',
      columns: {
        nr: 'Nr',
        name: 'Name',
        strasse: 'Straße',
        hausNr: 'Hausnummer',
        plz: 'PLZ',
        stadt: 'Stadt',
        land: 'Land',
        email: 'Email',
        group: 'Gruppe',
        vertrag: 'Vertrag-Nr',
        format: 'Bevorzugtes PoC-Format',
        verbraucher: 'Nutzt Verbraucherportal',
        code: 'Code',
        version: 'Version',
        mandantName: 'Mandant',
        mandantLand: 'Mandant-Land'
      },
      rules: {
        title: 'Regeln',
        noData: 'Keine Regeln vorhanden.',
        clear: 'Alle entfernen',
        add: 'Hinzufügen',
        addTitle: 'Regel hinzufügen',
        columns: {
          standort: 'Standort',
          priority: 'Priorität',
          biogehalt: 'Biogehalt (%)',
          biomenge: 'Biomenge (L)'
        }
      }
    },
    ablieferungen: {
      title: 'Ablieferungen',
      noData: 'Keine Ablieferungen vorhanden.',
      createTitle: 'Neue Ablieferung erstellen',
      editTitle: 'Ablieferung bearbeiten',
      deleteTitle: 'Ablieferung löschen',
      deleteConfirm: 'Möchten Sie diese Ablieferung wirklich löschen?',
      createSuccess: 'Ablieferung wurde erfolgreich erstellt',
      selectPartner: 'Partner auswählen',
      selectStandort: 'Standort auswählen',
      selectProdukt: 'Produkt auswählen',
      onlyWithNachweise: 'Nur Ablieferungen mit Nachweisen anzeigen',
      filter: {
        title: 'Filter',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        sendMail: 'Versenden',
        sendMailTooltip: 'Zum Versenden filtern Sie auf einen Empfänger',
        nr: 'Nr',
        standort: 'Standort',
        produkt: 'Produkt',
        partner: 'Empfänger',
        zeitraum: 'Zeitraum',
        allProducts: '(alle Produkte)',
        allStandorte: '(alle Standorte)',
        allPartners: '(alle Empfänger)'
      },
      statusDescriptions: {
        open: 'Die Ablieferung ist offen und kann bearbeitet werden',
        locked: 'Die Ablieferung ist gesperrt und kann nicht bearbeitet werden',
        inProgress: 'Die Ablieferung wird gerade bearbeitet',
        completed: 'Die Ablieferung wurde abgeschlossen'
      },
      placeholders: {
        nr: 'Nummer eingeben',
        menge: 'Menge eingeben',
        uom_menge: 'Einheit eingeben',
        biogehalt: 'Biogehalt eingeben',
        lieferdatum: 'Lieferdatum auswählen',
        typ: 'Typ eingeben',
        produkt_nr: 'Produkt Nr. eingeben',
        produkt_version: 'Produkt Version eingeben',
        partner_nr: 'Partner Nr. eingeben',
        standort_nr: 'Standort Nr. eingeben',
        contract_number: 'Vertragsnummer eingeben',
        status: 'Status eingeben',
        incoterm: 'Incoterm eingeben',
        vehicle_name: 'Fahrzeugname eingeben',
        kommentar: 'Kommentar eingeben',
        storniert: 'Storniert (0/1)',
        manuelle_eingabe: 'Manuelle Eingabe (0/1)',
        searchPartner: 'Partner suchen...',
        searchStandort: 'Standort suchen...',
        searchProdukt: 'Produkt suchen...',
        searchNr: 'Nach Nummer suchen...',
        searchName: 'Nach Name suchen...'
      },
      columns: {
        id: 'ID',
        nr: 'Nr',
        menge: 'Menge',
        uom_menge: 'Einheit',
        uomMenge: 'Einheit',
        einheit: 'Einheit',
        biogehalt: 'Biogehalt (%)',
        lieferdatum: 'Lieferdatum',
        typ: 'Typ',
        produkttyp: 'Produkttyp',
        produkt: 'Produkt',
        produkt_nr: 'Produkt Nr.',
        produktNr: 'Produkt Nr.',
        produkt_version: 'Produkt Version',
        partner: 'Partner',
        partner_nr: 'Partner Nr.',
        partnerNr: 'Partner Nr.',
        partner_version: 'Partner Version',
        standort: 'Standort',
        standort_nr: 'Standort Nr.',
        standortNr: 'Standort Nr.',
        standortCode: 'Standort Code',
        standort_version: 'Standort Version',
        mandantName: 'Mandant',
        mandantLand: 'Mandant Land',
        status: 'Status',
        status_name: 'Status Name',
        statusCode: 'Status Code',
        produktgruppe: 'Produktgruppe',
        produkt_gruppe: 'Produktgruppe',
        produktgruppe_name: 'Produktgruppe Name',
        contract_number: 'Vertragsnummer',
        contractNumber: 'Vertragsnummer',
        kommentar: 'Kommentar',
        manuelle_eingabe: 'Manuelle Eingabe',
        manuelleEingabe: 'Manuelle Eingabe',
        incoterm: 'Incoterm',
        incoterm_name: 'Incoterm Name',
        incotermName: 'Incoterm Name',
        vehicle_name: 'Fahrzeugname',
        vehicleName: 'Fahrzeugname',
        kartennummer: 'Kartennummer',
        storniert: 'Storniert',
        stornoParentId: 'Storno Parent ID'
      },
      sendReport: {
        tooltip: 'Nachweis versenden',
        title: 'Nachweise versenden',
        text: 'Sie können die Nachweise an mehrere Empfänger senden, wenn sie mehrere E-Mails durch Komma getrennt eingeben.',
        singleWasSent: 'Nachweis wird für den Versand vorbereitet.',
        bulkWasSent: 'Nachweise werden für den Versand vorbereitet.',
        generalError: 'Es ist ein Fehler aufgetreten, Nachweise konnten nicht versendet werden.',
        notSamePartnerError:
          'Es können nur Nachweise für einen ausgewählten Empfänger versendet werden.',
        missingToRecipients: 'Kein Empfänger angegeben.',
        ablieferungNotFound: 'Ablieferung wurde nicht gefunden.',
        noAblieferungenFound: 'Keine Ablieferungen gefunden.',
        missingReportName: 'Es konnte keine Reportvorlage gefunden werden.',
        containsAblieferungWithoutNachweis: 'Mindestens eine Ablieferung enthält keinen Nachweis.',
        containsMoreThanOnePartner:
          'Es können nur Nachweise für den selben Partner versendet werden.',
        ablieferungHasNoNachweis: 'Ablieferung enthält keinen Nachweis.',
        containsUnclosedAblieferung: 'Mindestens eine Ablieferung ist nicht abgeschlossen.',
        ablieferungNotClosed: 'Ablieferung ist nicht abgeschlossen.',
        exceedsMaxAllowedReports:
          'Es dürfen maximal {maxCount} Nachweise auf einmal versendet werden.'
      },
      nachweise: {
        available: 'Verfügbare Nachweise',
        assigned: 'Zugewiesene Nachweise',
        noAvailable: 'Keine verfügbaren Nachweise',
        noAssigned: 'Keine zugewiesenen Nachweise',
        assign: 'Zuweisen',
        assignSuccess: 'Nachweis erfolgreich zugewiesen',
        removeSuccess: 'Nachweis erfolgreich entfernt',
        volumen: 'Volumen',
        anteil: 'Anteil',
        volumenPlaceholder: 'Volumen eingeben',
        anteilPlaceholder: 'Anteil eingeben',
        addNew: 'Nachweis hinzufügen',
        assignTitle: 'Nachweis zuordnen',
        requiredBioAmount: 'Benötigte Biomenge',
        assignedAmount: 'Zugewiesene Menge',
        remainingAmount: 'Noch benötigte Menge',
        availableAmount: 'Verfügbare Menge',
        assignAmount: 'Zuzuweisende Menge',
        nr: 'Nachweis Nr.',
        detailView: 'Detailansicht',
        tableView: 'Tabellenansicht',
        createdAt: 'Erstellt am',
        produkt: 'Produkt',
        produktNr: 'Produkt Nr.',
        produktgruppe: 'Produktgruppe',
        produktgruppe_name: 'Produktgruppe Name',
        lieferdatum: 'Lieferdatum',
        available_volumen: 'Verfügbares Volumen',
        downloadReport: 'Nachweis herunterladen'
      },
      downloadReport: 'Ablieferungsnachweis herunterladen'
    },
    abholung: {
      title: 'Abholungen',
      noData: 'Keine Abholungen vorhanden.',
      editTitle: 'Abholung bearbeiten',
      createTitle: 'Abholung erstellen',
      deleteTitle: 'Abholung löschen',
      deleteConfirm: 'Sind Sie sicher, dass Sie diese Abholung löschen möchten?',
      filter: {
        title: 'Filter',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        nr: 'Nr',
        partner: 'Partner',
        produkt: 'Produkt',
        lieferant: 'Lieferant',
        zeitraum: 'Zeitraum',
        allProducts: '(alle Produkte)',
        allPartners: '(alle Partner)'
      },
      columns: {
        id: 'ID',
        nr: 'Nr',
        bilanzierungNr: 'Bilanzierungs-Nr',
        lieferdatum: 'Lieferdatum',
        lieferstelleNr: 'Lieferstelle Nr.',
        lieferstelleName: 'Lieferstelle Name',
        lieferstelle: 'Lieferstelle',
        lieferant: 'Lieferant',
        lieferantNr: 'Lieferant Nr.',
        contractNumber: 'Contract Nr.',
        mandantName: 'Mandant',
        mandantLand: 'Land',
        standortCode: 'Standort-Code',
        ablieferungId: 'Ablieferung-ID',
        ablieferungNr: 'Ablieferung-Nr.',
        produkt: 'Produkt',
        produktNr: 'Produkt Nr.',
        produktgruppe: 'Produktgruppe',
        produktgruppe_name: 'Produktgruppe Name',
        produktgruppeName: 'Produktgruppe Name',
        abgangProdukt: 'Abgangsprodukt',
        abgangProduktNr: 'Abgangsprodukt-Nr.',
        abgangProduktName: 'Abgangsprodukt',
        produkttyp_name: 'Produkttyp Name',
        produktTypName: 'Produkttyp Name',
        produkttyp: 'Typ',
        kraftstoffmenge: 'Kraftstoffmenge',
        menge: 'Menge',
        volumen: 'Menge',
        volumenVerbleibend: 'Verbleibende Menge',
        anteil: 'Anteil',
        biogehalt: 'Biogehalt'
      },
      nachweise: {
        title: 'Nachweise',
        nachweis: 'Nachweis',
        add: 'Nachweis hinzufügen',
        addNew: 'Neuen Nachweis erstellen',
        edit: 'Nachweis bearbeiten',
        id: 'ID',
        nachweisNr: 'Nachweis-Nr.',
        nnwAnteil: 'NNW Anteil',
        thgEmission: 'THG Emission',
        attributAnnexIx: 'Attribut Annex',
        anbauland: 'Anbauland',
        rohstoff: 'Rohstoff',
        biomasseArt: 'Biomasse Art',
        biomasseCode: 'Biomasse Code',
        nnwEnergie: 'NNW Energie',
        nnwProduktName: 'NNW Produkt Name',
        nnwProduktNr: 'NNW Produkt Nr.',
        zertifizierungssystem: 'Zertifizierungssystem'
      },
      einlieferungen: {
        title: 'Einlieferungen',
        aktuelleVerknuepfungen: 'Aktuelle Verknüpfungen',
        keineVerknuepfungen: 'Keine Einlieferungen verknüpft',
        verfuegbareEinlieferungen: 'Verfügbare Einlieferungen',
        einlieferungenAuswaehlen: 'Einlieferungen auswählen',
        keineEinlieferungenVerfuegbar: 'Keine Einlieferungen verfügbar',
        columns: {
          nr: 'Einlieferungs-Nr',
          entladedatum: 'Entladedatum',
          entladeneMenge: 'Entladene Menge',
          typ: 'Typ'
        }
      },
      placeholders: {
        selectDate: 'Datum auswählen',
        nr: 'Nummer eingeben',
        menge: 'Menge eingeben',
        volumen: 'Volumen eingeben',
        anteil: 'Anteil eingeben',
        lieferstelleNr: 'Lieferstelle Nr. eingeben',
        lieferstelleName: 'Lieferstelle Name eingeben',
        selectLieferstelle: 'Lieferstelle auswählen',
        selectPartner: 'Lieferant auswählen',
        ablieferungId: 'Ablieferungs-ID eingeben',
        ablieferungNr: 'Ablieferungs-Nr. eingeben',
        produktgruppe: 'Produktgruppe eingeben',
        abgangProduktNr: 'Abgangsprodukt Nr. eingeben',
        abgangProduktName: 'Abgangsprodukt Name eingeben',
        produkttyp: 'Produkttyp eingeben'
      },
      validation: {
        nachweisRequired: 'Mindestens ein Nachweis ist erforderlich'
      },
      selectLieferstelle: 'Lieferstelle auswählen',
      selectProduktTyp: 'Produkttyp auswählen',
      selectProduktGruppe: 'Produktgruppe auswählen',
      selectProdukt: 'Produkt auswählen'
    },
    einlieferungen: {
      title: 'Einlieferungen',
      noData: 'Keine Einlieferungen vorhanden.',
      editTitle: 'Einlieferung bearbeiten',
      createTitle: 'Einlieferung erstellen',
      deleteTitle: 'Einlieferung löschen',
      deleteConfirm: 'Möchten Sie diese Einlieferung wirklich löschen?',
      verknuepfteAbholung: 'Verknüpfte Abholung',
      aktuelleVerknuepfung: 'Aktuelle Verknüpfung',
      keineVerknuepfung: 'Keine Abholung verknüpft',
      verfuegbareAbholungen: 'Verfügbare Abholungen',
      abholungAuswaehlen: 'Abholung auswählen',
      keineVerfuegbarenAbholungen: 'Keine verfügbaren Abholungen',
      keineVerfuegbarenAbholungenHinweis:
        'Es gibt derzeit keine Abholungen, die mit dieser Einlieferung verknüpft werden können.',
      confirmNrChange: 'Möchten Sie die Einlieferungsnummer wirklich ändern?',
      selectPartner: 'Partner auswählen',
      selectStandort: 'Standort auswählen',
      selectProdukt: 'Produkt auswählen',
      filter: {
        title: 'Filter',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        nr: 'Nr',
        standort: 'Standort',
        produkt: 'Produkt',
        partner: 'Partner',
        zeitraum: 'Zeitraum',
        allProducts: '(alle Produkte)',
        allStandorte: '(alle Standorte)',
        allPartners: '(alle Partner)'
      },
      placeholders: {
        searchPartner: 'Partner suchen...',
        searchStandort: 'Standort suchen...',
        searchProdukt: 'Produkt suchen...',
        searchNr: 'Nach Nummer suchen...',
        searchName: 'Nach Name suchen...',
        selectDate: 'Datum auswählen',
        selectUom: 'Einheit auswählen',
        selectTyp: 'Typ auswählen',
        selectProduktgruppe: 'Produktgruppe auswählen',
        nr: 'Nummer eingeben',
        typ: 'Typ eingeben',
        entladeneMenge: 'Menge eingeben',
        biogehalt: 'Biogehalt eingeben',
        produktgruppe: 'Produktgruppe eingeben',
        contractNumber: 'Vertragsnummer eingeben',
        incoterm: 'Incoterm eingeben',
        vehicleName: 'Fahrzeugname eingeben',
        kommentar: 'Kommentar eingeben'
      },
      abholungen: {
        columns: {
          nr: 'Nr',
          lieferdatum: 'Lieferdatum',
          volumen: 'Volumen',
          verfuegbaresVolumen: 'Verfügbares Volumen',
          produktgruppe: 'Produktgruppe',
          lieferstelle: 'Lieferstelle',
          ablieferungNr: 'Ablieferungs-Nr'
        }
      },
      columns: {
        nr: 'Nr',
        typ: 'Typ',
        biogehalt: 'Biogehalt (%)',
        entladeneMenge: 'Entladene Menge',
        uomEntladeneMenge: 'Einheit (entladen)',
        geladeneMenge: 'Geladene Menge',
        uomGeladeneMenge: 'Einheit (geladen)',
        beladedatum: 'Beladedatum',
        unitOfMeasure: 'Einheit',
        entladedatum: 'Entladedatum',
        status: 'Status',
        statusName: 'Status Name',
        statusCode: 'Status Code',
        mandantName: 'Mandant',
        mandantLand: 'Mandant Land',
        manuelleEingabe: 'Manuelle Eingabe',
        partnerNr: 'Partner-Nr',
        partner: 'Partner',
        partnerVersion: 'Partner Version',
        standortNr: 'Standort-Nr',
        standort: 'Standort',
        standortCode: 'Standort Code',
        standortVersion: 'Standort Version',
        produktNr: 'Produkt-Nr',
        produkt: 'Produkt',
        produktVersion: 'Produkt Version',
        produktgruppe: 'Produktgruppe',
        produkttyp: 'Typ',
        contractNumber: 'Vertragsnummer',
        incoterm: 'Incoterm',
        incotermName: 'Incoterm Name',
        vehicleName: 'Fahrzeugname',
        kommentar: 'Kommentar',
        storniert: 'Storniert',
        stornoParentId: 'Storno Parent ID',
        commodityGroup: 'Commodity Group',
        productCode: 'Product Code',
        maxVolumen: 'Max. Volumen'
      },
      status: {
        open: 'Offen',
        locked: 'Gesperrt',
        inProgress: 'In Bearbeitung',
        completed: 'Abgeschlossen'
      },
      statusDescriptions: {
        open: 'Die Einlieferung ist offen und kann bearbeitet werden',
        locked: 'Die Einlieferung ist gesperrt und kann nicht bearbeitet werden',
        inProgress: 'Die Einlieferung wird gerade bearbeitet',
        completed: 'Die Einlieferung wurde abgeschlossen'
      },
      validation: {
        requiredFields: 'Bitte füllen Sie alle Pflichtfelder aus',
        invalidNumber: 'Bitte geben Sie eine gültige Nummer ein',
        invalidDate: 'Bitte geben Sie ein gültiges Datum ein',
        invalidAmount: 'Bitte geben Sie eine gültige Menge ein'
      },
      messages: {
        createSuccess: 'Einlieferung wurde erfolgreich erstellt.',
        updateSuccess: 'Einlieferung wurde erfolgreich aktualisiert.',
        deleteSuccess: 'Einlieferung wurde erfolgreich gelöscht.',
        linkSuccess: 'Verknüpfung wurde erfolgreich erstellt.',
        unlinkSuccess: 'Verknüpfung wurde erfolgreich aufgehoben.'
      }
    },
    standorte: {
      title: 'Standorte',
      createTitle: 'Neuen Standort erstellen',
      editTitle: 'Standort bearbeiten',
      deleteTitle: 'Standort löschen',
      deleteConfirm: 'Möchten Sie diesen Standort wirklich löschen?',
      columns: {
        nr: 'Nr',
        name: 'Name',
        strasse: 'Straße',
        hausNr: 'Hausnummer',
        plz: 'PLZ',
        stadt: 'Stadt',
        land: 'Land',
        code: 'Kennzeichen',
        anlage: 'Anlage-Nr',
        quota: 'Quotenpflichtig?'
      }
    },
    produkte: {
      title: 'Produkte',
      createTitle: 'Neues Produkt erstellen',
      editTitle: 'Produkt bearbeiten',
      deleteTitle: 'Produkt löschen',
      deleteConfirm: 'Möchten Sie dieses Produkt wirklich löschen?',
      columns: {
        nr: 'Nr',
        name: 'Name',
        biogehalt: 'Biogehalt',
        lcv: 'Unterer Heizwert (MJ/kg oder MJ/L)',
        beschreibung: 'Beschreibung',
        produktgruppe: 'Produktgruppe',
        produkttyp: 'Produkttyp',
        produktgruppeCode: 'Produktgruppe-Code',
        produkttypCode: 'Produkttyp-Code',
        thg: 'THG',
        version: 'Version',
        mandantName: 'Mandant',
        mandantLand: 'Mandant-Land',
        status: 'Status',
        kommentar: 'Kommentar'
      },
      status: {
        aktiv: 'Aktiv',
        inaktiv: 'Inaktiv'
      },
      produktgruppen: {
        diesel: 'Diesel',
        benzin: 'Benzin',
        biodiesel: 'Biodiesel',
        bioethanol: 'Bioethanol',
        hvo: 'HVO',
        pflanzenoel: 'Pflanzenöl'
      }
    },
    zertifizierungen: {
      title: 'Zertifizierungen',
      createTitle: 'Neue Zertifizierung',
      deleteTitle: 'Zertifizierung löschen',
      deleteConfirm: 'Sind Sie sicher, dass Sie diese Zertifizierung löschen wollen?',
      updateTitle: 'Zertifizierung aktualisieren',
      columns: {
        nr: 'Nr',
        von: 'Gültig von',
        bis: 'Gültig bis'
      }
    },
    nachweisbescheinigungen: {
      title: 'Nachweisbescheinigungen',
      noData: 'Keine Nachweise vorhanden.',
      createTitle: 'Neue Nachweisbescheinigung erstellen',
      editTitle: 'Nachweisbescheinigung bearbeiten',
      deleteTitle: 'Nachweisbescheinigung löschen',
      deleteConfirm: 'Möchten Sie diese Nachweisbescheinigung wirklich löschen?',
      filter: {
        title: 'Filter',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        standort: 'Standort',
        produkt: 'Produkt',
        zeitraum: 'Zeitraum',
        allProducts: '(alle Produkte)',
        allStandorte: '(alle Standorte)'
      },
      detail: {
        title: 'Nachweisbescheinigung Details',
        basicInfo: 'Grundinformationen',
        productInfo: 'Produktinformationen',
        linkedDeliveries: 'Verknüpfte Einlieferungen',
        linkedPickups: 'Verknüpfte Abholungen',
        abholungInfo: 'Abholung Informationen',
        abholungNachweise: 'Nachweisbescheinigungen der Abholung'
      },
      tabs: {
        general: 'Allgemein',
        einlieferungen: 'Einlieferungen',
        abholungen: 'Abholungen',
        ablieferungen: 'Ablieferungen'
      },
      columns: {
        id: 'ID',
        nachweisNr: 'Nachweis-Nr',
        volumen: 'Volumen',
        volumenVerbleibend: 'Verfügbares Volumen',
        produktNr: 'Produkt-Nr',
        produktgruppe: 'Produktgruppe',
        produktgruppeName: 'Produktgruppenname',
        produkt: 'Produkt',
        produkttyp: 'Produkttyp',
        standort: 'Standort',
        standortNr: 'Standort-Nr',
        standortCode: 'Standort-Code',
        tauschpartner: 'Partner',
        partnerNr: 'Partner-Nr',
        einlieferungNr: 'Einlieferung-Nr',
        einlieferungId: 'Einlieferung-ID',
        abholungId: 'Abholung-ID',
        mandantName: 'Mandant',
        mandantLand: 'Mandant-Land',
        lieferdatum: 'Lieferdatum',
        referenzNachweisNr: 'Referenz Nachweis-Nr',
        nnwAnteil: 'NNW Anteil',
        nnwEnergie: 'NNW Energie',
        thgEmission: 'THG Emission',
        nnwProduktName: 'NNW Produkt',
        nnwProduktNr: 'NNW Produkt-Nr',
        rohstoff: 'Rohstoff',
        biomasseArt: 'Biomasse Art',
        biomasseCode: 'Biomasse Code',
        anbauland: 'Anbauland',
        zertifizierungsystem: 'Zertifizierungssystem'
      },
      endNachweise: {
        title: 'End-Nachweise'
      },
      placeholders: {
        nachweisNr: 'Nachweis-Nr eingeben',
        volumen: 'Volumen eingeben',
        volumenVerbleibend: 'Verfügbares Volumen eingeben',
        produktNr: 'Produkt-Nr eingeben',
        produktgruppe: 'Produktgruppe eingeben',
        produktgruppeName: 'Produktgruppenname eingeben',
        produkt: 'Produkt eingeben',
        lieferdatum: 'Lieferdatum auswählen'
      }
    },
    nachweisverteilung: {
      title: 'Nachweisverteilung',
      resetTitle: 'Nachweisverteilung zurücksetzen',
      resetText:
        'Sind Sie sicher, dass Sie die Nachweisverteilung zurücksetzen möchten? Alle Zuordnungen werden dabei gelöscht.',
      invalidTitle: 'Nachweisverteilung unvollständig',
      invalidText:
        'Nachweisverteilung kann nicht gespeichert werden, weil zumindest eine Ablieferung noch nicht zugeteilte Menge hat.',
      saveTitle: 'Nachweisverteilung speichern',
      saveText: 'Sind Sie sicher, dass Sie die Nachweisverteilung speichern möchten?',
      filter: {
        title: 'Filter',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        nr: 'Nr',
        standort: 'Standort',
        produkt: 'Produkt',
        partner: 'Kunde',
        zeitraum: 'Zeitraum',
        allProducts: '(alle Produkte)',
        allStandorte: '(alle Standorte)',
        allPartners: '(alle Kunden)'
      },
      messages: {
        saved: 'Nachweisverteilung wurde erfolgreich gespeichert.',
        saveError: 'Nachweisverteilung konnte nicht gespeichert werden.'
      }
    },
    benutzer: {
      administration: {
        title: 'Benutzerverwaltung',
        description: 'Verwalten Sie hier alle Benutzer und deren Berechtigungen',
        breadcrumb: {
          administration: 'Administration',
          users: 'Benutzer'
        },
        noPermission: {
          title: 'Keine Berechtigung',
          message:
            'Sie haben keine Berechtigung, auf die Benutzeradministration zuzugreifen. Diese Funktion ist nur für System- und Mandantenadministratoren verfügbar.'
        },
        actions: {
          newUser: 'Neuer Benutzer',
          edit: 'Bearbeiten',
          resetPassword: 'Passwort zurücksetzen',
          reset2fa: '2FA zurücksetzen',
          delete: 'Löschen'
        },
        columns: {
          user: 'Benutzer',
          login: 'Login',
          status: 'Status',
          role: 'Rolle'
        },
        status: {
          active: 'Aktiv',
          inactive: 'Inaktiv'
        },
        roles: {
          systemAdmin: 'System-Admin',
          admin: '(Admin)'
        },
        placeholders: {
          searchColumn: '{column} suchen...'
        },
        errors: {
          loadUsers:
            'Die Benutzer konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
          deleteUser:
            'Der Benutzer konnte nicht gelöscht werden. Bitte versuchen Sie es später erneut.',
          saveUser:
            'Der Benutzer konnte nicht gespeichert werden. Bitte versuchen Sie es später erneut.',
          resetMfa:
            'Die 2FA konnte nicht zurückgesetzt werden. Bitte versuchen Sie es später erneut.'
        }
      },
      permissions: {
        title: 'Berechtigungen',
        description: 'Übersicht über Ihre Berechtigungen und zugewiesenen Rollen',
        errors: {
          general: 'Es ist ein Fehler aufgetreten.',
          loadRoles: 'Rollen konnten nicht geladen werden.',
          loadData: 'Daten konnten nicht geladen werden.',
          loadUsers: 'Benutzer konnten nicht geladen werden.'
        }
      },
      passwordChange: {
        title: 'Passwort ändern',
        form: {
          currentPassword: 'Aktuelles Passwort',
          newPassword: 'Neues Passwort',
          confirmPassword: 'Neues Passwort bestätigen',
          submitButton: 'Passwort ändern'
        },
        requirements: {
          title: 'Das Passwort muss:',
          minLength: 'Mindestens 8 Zeichen lang sein',
          uppercase: 'Mindestens einen Großbuchstaben enthalten',
          lowercase: 'Mindestens einen Kleinbuchstaben enthalten',
          number: 'Mindestens eine Zahl enthalten'
        },
        errors: {
          passwordMismatch: 'Die Passwörter stimmen nicht überein',
          incorrectCurrent:
            'Das eingegebene aktuelle Passwort ist nicht korrekt. Bitte überprüfen Sie Ihre Eingabe.',
          changeFailed:
            'Das Passwort konnte nicht geändert werden. Bitte versuchen Sie es später erneut.'
        },
        success: {
          message:
            'Ihr Passwort wurde erfolgreich geändert. Bitte verwenden Sie ab sofort Ihr neues Passwort für die Anmeldung.'
        }
      },
      deleteTitle: 'Benutzer löschen',
      deleteConfirm: 'Möchten Sie diesen Benutzer wirklich löschen?',
      userDetails: {
        login: 'Login',
        name: 'Name'
      }
    },
    tankstelleBestand: {
      title: 'Übersichtsseite Tankstelle',
      simulateDelivery: 'Einlieferung simulieren',
      tankDetails: 'Tank-Details',
      productDetails: 'Produkt-Details',
      deliveryHistory: 'Einlieferungshistorie',
      tankLevel: 'Füllstand',
      capacity: 'Kapazität',
      currentLevel: 'Aktueller Füllstand',
      lastDelivery: 'Letzte Einlieferung',
      noDeliveries: 'Keine Einlieferungen vorhanden',
      liters: 'Liter',
      date: 'Datum',
      amount: 'Menge',
      supplier: 'Lieferant',
      product: 'Produkt',
      bioContent: 'Biogehalt',
      deliveryDetails: 'Einlieferungsdetails',
      deliveryNumber: 'Einlieferungsnummer',
      deliveryDate: 'Einlieferungsdatum',
      deliveryAmount: 'Einlieferungsmenge',
      certificates: 'Nachweise',
      certificateNumber: 'Nachweisnummer',
      certificateAmount: 'Nachweismenge',
      certificatePercentage: 'Nachweisanteil',
      noCertificates: 'Keine Nachweise vorhanden',
      overviewTab: 'Übersicht',
      tanksTab: 'Tanks',
      visualizationTitle: 'Übersicht Tankstelle',
      tankVisualization: 'Darstellung Tank an der Tankstelle',
      tankDescription: 'Speichert Lieferungen und deren THG-Einsparungen',
      pumpVisualization: 'Darstellung Zapfsäule',
      thgValue: 'THG Wert',
      recentDeliveries: 'Liste der letzten 10 Ablieferungen',
      detailView: 'Detailansicht',
      supplyChainView: 'siehe Darstellung der Lieferkette',
      levelLineDescription:
        'Die blaue Fläche zeigt den aktuellen Stand der Aufteilung der Nachweisbescheinigungen',
      newDeliveryInfo: 'Wenn neue Einlieferung dazu kommt, erhöht sich der Tankinhalt.',
      deliveryStatus: {
        withCertificate: 'Mit finaler Nachweisbescheinigung',
        withoutCertificate: 'Ohne finale Nachweisbescheinigung',
        noCertificate: 'Keine Nachweisbescheinigung'
      },
      einlieferungStatus: {
        notLinked: 'Nicht verknüpft',
        dummyCertificate: 'Vorläufiger Nachweis',
        realCertificate: 'Finaler Nachweis'
      },
      modalWarning: {
        title: 'Keine Nachweise verfügbar',
        content:
          'Für diese Ablieferung sind keine Nachweisbescheinigungen im System hinterlegt. Die Nachweisverfolgung wird keine Daten anzeigen können.',
        cancel: 'Abbrechen',
        proceed: 'Trotzdem fortfahren'
      },
      thgSavings: {
        realSaving: 'Reale Einsparung',
        projectedSaving: 'Prognostizierte Einsparung',
        comparison: 'Diese Einsparung entspricht etwa:',
        carTrips: 'Autofahrten (100 km)',
        flights: 'Flüge (500 km)',
        meatConsumption: 'kg Fleischkonsum'
      },
      deliveryStatusLabel: 'Status der Einlieferungen:',
      tankStatusLabel: 'Tank-Ampel Status:',
      tankStatus: {
        sufficient: 'Ausreichend verfügbar',
        followUpAvailable: 'Ausreichend mit Nachfolger',
        lowFollowUpPending: 'Gering verfügbar mit Nachfolger',
        lowNoFollowUp: 'Gering verfügbar ohne Nachfolger',
        inactive: 'Keine aktive Einlieferung',
        noDelivery: 'Keine Einlieferungen vorhanden',
        provisional: 'Vorläufiger Nachweis'
      },
      results: {
        recentDeliveries: 'Die 10 aktuellsten Ablieferungen werden angezeigt.',
        onlyProduct: 'Nur Produkt:',
        clickForDetails: 'Klicken Sie auf eine Ablieferung, um Details anzuzeigen'
      },
      noData: 'Keine THG-Daten verfügbar',
      thgInfoModal: {
        title: 'THG Einsparungen:',
        close: 'Schließen'
      },
      filter: {
        title: 'Tankstelle & Produkt wählen',
        loading: 'Lade Tankstellendaten...',
        error: {
          title: 'Fehler beim Laden der Daten',
          retry: 'Erneut versuchen',
          defaultMessage: 'Bitte versuchen Sie es später erneut.'
        }
      },
      ablieferungen: {
        filterTitle: 'Gefiltert nach Produkt:',
        number: 'Nr:',
        showFullNumber: 'Vollständige Ablieferungsnummer anzeigen',
        liter: 'l'
      },
      pump: {
        thgSaving: 'THG EINSPARUNG'
      },
      actions: {
        details: 'Details',
        supplyChain: 'Lieferkette'
      },
      einlieferungen: {
        date: 'Datum',
        ablieferungId: 'ABLIEFERUNGS-ID:',
        generalInfo: 'Allgemeine Informationen',
        id: 'ID',
        maxVolume: 'Max. Volumen',
        address: 'Standortadresse',
        recentDeliveries: 'Letzte Ablieferungen',
        deliveryNumber: 'Ablieferungs-Nr',
        noAvailable: 'Keine Ablieferungen verfügbar',
        title: 'Ablieferungsdetails',
        noDataAvailable: 'Keine Daten verfügbar.',
        receiver: 'Empfänger',
        unknown: 'Unbekannt',
        deliveryDate: 'Lieferdatum',
        product: 'Produkt',
        thgCertificate: 'THG-Nachweis',
        available: 'Vorhanden',
        notAvailable: 'Nicht vorhanden',
        location: {
          title: 'Standort-Informationen',
          name: 'Name',
          address: 'Adresse',
          place: 'Ort',
          country: 'Land',
          number: 'Standort-Nr'
        },
        receiverInfo: {
          title: 'Empfänger-Informationen',
          name: 'Name',
          address: 'Adresse',
          place: 'Ort',
          contact: 'Kontaktperson',
          phone: 'Telefon',
          email: 'E-Mail'
        },
        thgInfo: {
          title: 'THG-Nachweis Informationen',
          id: 'Nachweis-ID',
          saving: 'Einsparung',
          source: 'Quellmaterial',
          date: 'Ausgestellt am',
          status: 'Status',
          uerValue: 'UER-Wert'
        },
        extendedInfo: {
          title: 'Erweiterte Informationen',
          bioContent: 'Biogehalt',
          productType: 'Produkttyp',
          productGroup: 'Produktgruppe'
        }
      },
      nachweisverfolgung: 'Nachweisverfolgung'
    },
    nachweisverfolgung: {
      title: 'Übersicht Nachweisverfolgung',
      filter: {
        title: 'Filter',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        standort: 'Standort',
        produkt: 'Produkt',
        partner: 'Empfänger',
        zeitraum: 'Zeitraum',
        allProducts: '(alle Produkte)',
        allStandorte: '(alle Standorte)',
        allPartner: '(alle Empfänger)'
      },
      columns: {
        datum: 'Datum',
        produkt: 'Produkt',
        menge: 'Menge',
        empfaenger: 'Empfänger'
      },
      viewTraceability: 'Nachweisverfolgung anzeigen',
      noData: 'Keine Ablieferungen vorhanden.',
      table: {
        certificateNumber: 'Nachweisnummer',
        productType: 'Produkttyp',
        amount: 'Menge',
        date: 'Datum',
        supplier: 'Lieferant',
        status: 'Status',
        details: 'Details'
      },
      details: {
        title: 'Nachweisverfolgung Details',
        certificate: 'Nachweis',
        deliveries: 'Einlieferungen',
        stations: 'Tankstellen',
        path: 'Verlauf',
        origin: 'Ursprung',
        destination: 'Ziel',
        intermediate: 'Zwischenstationen',
        noData: 'Keine Daten vorhanden'
      },
      status: {
        active: 'Aktiv',
        used: 'Verwendet',
        expired: 'Abgelaufen',
        pending: 'Ausstehend'
      },
      legend: {
        title: 'Legende',
        abholung: 'Nachweisbescheinigung Abholung',
        ablieferung: 'Nachweisbescheinigung Ablieferung',
        einlieferung: 'Nachweisbescheinigung Einlieferung'
      },
      modal: {
        details: 'Details',
        description: 'Beschreibung',
        nr: 'Nr',
        date: 'Datum',
        noDocument: 'Kein Nachweis verknüpft',
        close: 'Schließen'
      }
    },
    bestaende: {
      title: 'Bestände',
      noData: 'Keine Bestände vorhanden.',
      createTitle: 'Neuen Bestand erstellen',
      editTitle: 'Bestand bearbeiten',
      deleteTitle: 'Bestand löschen',
      deleteConfirm: 'Möchten Sie diesen Bestand wirklich löschen?',
      delete_title: 'Bestand löschen',
      delete_confirmation: 'Möchten Sie den Bestand #{id} ({produkt}) wirklich löschen?',
      delete_warning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      filter: {
        title: 'Filter',
        apply: 'Anwenden',
        reset: 'Zurücksetzen',
        standort: 'Standort',
        produkt: 'Produkt',
        zeitraum: 'Zeitraum',
        allProducts: '(alle Produkte)',
        allStandorte: '(alle Standorte)'
      },
      columns: {
        id: 'ID',
        datum: 'Datum',
        standort: 'Standort',
        standortNr: 'Standort-Nr',
        standortCode: 'Standort-Code',
        standort_nr: 'Standort-Nr',
        produkt: 'Produkt',
        produktNr: 'Produkt-Nr',
        produkt_nr: 'Produkt-Nr',
        volumen: 'Volumen',
        fuellstand: 'Füllstand',
        mandant: 'Mandant',
        mandantName: 'Mandant',
        mandantLand: 'Mandant-Land',
        deliveryVolumen: 'Liefermenge',
        deliveryStart: 'Lieferbeginn',
        deliveryEnd: 'Lieferende'
      },
      placeholders: {
        searchProdukt: 'Produkt suchen...',
        searchStandort: 'Standort suchen...',
        selectDate: 'Datum auswählen'
      },
      selectProdukt: 'Produkt auswählen',
      selectStandort: 'Standort auswählen',
      errors: {
        loadFailed: 'Fehler beim Laden des Bestands.',
        updateFailed: 'Fehler beim Aktualisieren des Bestands.',
        createFailed: 'Fehler beim Erstellen des Bestands.',
        missingFields: 'Bitte füllen Sie alle Pflichtfelder aus'
      },
      success: {
        createSuccess: 'Bestand wurde erfolgreich erstellt.',
        updateSuccess: 'Bestand wurde erfolgreich aktualisiert.',
        deleteSuccess: 'Bestand wurde erfolgreich gelöscht.'
      }
    },
    mandanten: {
      title: 'Mandantenverwaltung',
      addMandant: 'Mandanten erstellen',
      editMandant: 'Mandanten bearbeiten',
      deleteMandant: 'Mandanten löschen',
      confirmDelete:
        'Sind Sie sicher, dass Sie den Mandanten "{name}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      userSection: 'Benutzer',
      addUser: 'Benutzer hinzufügen',
      editUser: 'Benutzer bearbeiten',
      noUsers: 'Keine Benutzer gefunden',
      status: {
        active: 'aktiv',
        inactive: 'inaktiv',
        activate: 'Aktivieren',
        deactivate: 'Deaktivieren'
      },
      columns: {
        name: 'Mandant',
        id: 'ID',
        email: 'E-Mail',
        strasse: 'Straße',
        hausNr: 'Haus-Nr',
        plz: 'PLZ',
        stadt: 'Stadt',
        land: 'Land',
        status: 'Status',
        zertifizierung: 'Zertifizierung-Nr'
      },
      address: 'Adresse',
      errors: {
        loadFailed:
          'Die Mandanten konnten nicht geladen werden. Bitte versuchen Sie es später erneut.',
        saveFailed:
          'Der Mandant konnte nicht gespeichert werden. Bitte versuchen Sie es später erneut.',
        statusChangeFailed:
          'Der Status konnte nicht geändert werden. Bitte versuchen Sie es später erneut.',
        deleteFailed:
          'Der Mandant konnte nicht gelöscht werden. Bitte versuchen Sie es später erneut.',
        loadUsersFailed: 'Die Benutzer konnten nicht geladen werden.',
        saveUserFailed: 'Der Benutzer konnte nicht gespeichert werden.'
      }
    },
    reports: {
      liste: {
        title: 'Berichte',
        noReportsAvailable: 'Keine Berichte verfügbar',
        error: 'Es ist ein Fehler aufgetreten',
        actions: {
          cancel: 'Abbrechen',
          generate: 'Bericht generieren',
          generating: 'Wird generiert...',
          send: 'Versenden'
        },
        mail: {
          wasSent: 'Bericht wurde erfolgreich versendet.',
          title: 'Bericht versenden',
          text: 'Sie können den Bericht an mehrere Empfänger senden, wenn sie mehrere E-Mails durch Semikolon getrennt eingeben.',
          generalError: 'Es ist ein Fehler aufgetreten, Bericht konnte nicht versendet werden.',
          reportCreationFailed: 'Bericht konnte nicht generiert werden.',
          reportSendingFailed: 'Bericht konnte nicht versendet werden.',
          missingToRecipients: 'Bitte geben Sie mindestens einen Empfänger an.',
          missingReportName: 'Berichtsname fehlt.'
        },
        validation: {
          requiredFields: 'Bitte füllen Sie alle erforderlichen Felder aus: {fields}',
          noAuth: 'Keine Authentifizierung vorhanden',
          error: 'Beim Generieren des Berichts  ist ein Fehler aufgetreten.',
          success: 'Bericht wurde erfolgreich generiert.'
        },
        errors: {
          loading: 'Fehler beim Laden der Berichte: {status} {statusText}.',
          unknown: 'Unbekannter Fehler beim Laden der Berichte.',
          generation: 'Fehler beim Generieren des Berichts.'
        }
      },
      parameters: {
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        partner: 'Partner',
        standort: 'Standort',
        produkt: 'Produkt'
      }
    },
    import: {
      title: 'Datenimport',
      file: 'Datei',
      uploadFile: 'Datei hochladen',
      upload: 'Hochladen',
      type: 'Typ',
      import: 'Daten importieren',
      confirm: 'Möchten Sie die Daten tatsächlich importieren?',
      messages: 'Importmeldungen',
      columns: {
        importStatus: 'Status',
        importError: 'Fehler',
        importIdentifier: 'Identifier',
        insertDate: 'Eingefügt',
        importDate: 'Importversuch',
        importCodes: 'Import Codes'
      }
    },
    ytd: {
      title: 'YTD Übersicht',
      jahr: 'Jahr',
      produkt: 'Produkt',
      selectProdukt: '(bitte Produkt auswählen)',
      selectJahr: '(bitte Jahr auswählen)',
      columns: {
        airport: 'Flughafen',
        airlines: 'Fluggesellschaft',
        ytdPocMenge: 'YTD PoC-Menge',
        ytdSollMenge: 'YTD Soll-Menge',
        ytdDiffMenge: 'YTD Differenz',
        ytdZusatzMenge: 'YTD Zusatz-Menge',
        ytdPocTotalMenge: 'YTD PoC-Menge (alle Standorte)',
        ytdSollTotalMenge: 'YTD Soll-Menge (alle Standorte)'
      }
    }
  },
  entities: {
    produkt: 'Produkt',
    standort: 'Standort',
    partner: 'Partner',
    abholung: 'Abholung',
    einlieferung: 'Einlieferung',
    ablieferung: 'Ablieferung',
    bestand: 'Bestand',
    nachweisbescheinigung: 'Nachweisbescheinigung',
    zertifikat: 'Nachweis',
    inbound: 'Eingehende Daten',
    outbound: 'Ausgehende Daten',
    bilanz: 'Verteilung',
    nachweis: 'Nachweis',
    zertifizierung: 'Zertifizierung'
  },
  errors: {
    loading: 'Fehler beim Laden von {entity}',
    invalidId: 'Ungültige ID',
    invalidData: 'Ungültige Daten',
    createError: '{entity} konnte nicht erstellt werden.',
    updateError: '{entity} konnte nicht aktualisiert werden.',
    deleteError: '{entity} konnte nicht gelöscht werden.',
    importError: 'Daten konnten nicht importiert werden.',
    loadError: 'Daten konnten nicht geladen werden.',
    downloadError: '{entity} konnte nicht heruntergeladen werden.',
    notFound: '{entity} wurde nicht gefunden.',
    uploadError:
      'Datei konnte nicht hochgeladen/verarbeitet werden. Evtl. enthält sie inkorrekte Daten oder Datenfehler.',
    unexpected: 'Ein unerwarteter Fehler ist aufgetreten',
    serverError: 'Der Server ist nicht erreichbar',
    validationError: 'Bitte überprüfen Sie Ihre Eingaben',
    accessDenied: 'Zugriff verweigert',
    saving: 'Fehler beim Speichern von {entity}',
    deleting: 'Fehler beim Löschen von {entity}',
    verknuepfen: 'Fehler beim Verknüpfen',
    alreadyLinked: 'Diese Einlieferung ist bereits mit der Abholung {nr} verknüpft'
  },
  warning: {
    missingOrInvalid: 'Fehlende oder ungültige Werte in: ',
    wartungsfenster: {
      sessionWillBeTerminated: 'Wartungsfenster aktiv - Ihre Session wird in Kürze beendet.',
      sessionWillBeTerminatedEndWork:
        'Wartungsfenster aktiv - Ihre Session wird in Kürze beendet. Bitte schließen Sie Ihre Arbeit ab.'
    }
  },
  success: {
    created: '{entity} wurde erfolgreich erstellt.',
    updated: '{entity} wurde erfolgreich aktualisiert.',
    deleted: '{entity} wurde erfolgreich gelöscht.',
    imported: 'Daten wurden erfolgreich importiert.',
    saved: 'Daten wurden erfolgreich gespeichert.',
    verknuepft: 'Verknüpfung wurde erfolgreich hergestellt.',
    added: '{entity} wurde erfolgreich hinzugefügt.'
  },
  dashboard: {
    title: 'Dashboard',
    stats: {
      users: 'Aktive Benutzer',
      deliveries: 'Lieferungen',
      products: 'Produkte',
      documents: 'Dokumente'
    },
    recent_activities: 'Letzte Aktivitäten',
    activities: {
      new_user: 'Neuer Benutzer registriert',
      document_updated: 'Dokument aktualisiert',
      delivery_completed: 'Lieferung abgeschlossen'
    },
    system_alerts: 'System Meldungen',
    alerts: {
      system_update: 'System-Update geplant',
      disk_space: 'Speicherplatz wird knapp'
    },
    welcome: 'Willkommen bei CEETRAC',
    welcome_message: 'Ihr zentrales Portal für Nachhaltigkeitsnachweise und Lieferkettentransparenz'
  },
  components: {
    pagination: {
      back: 'Zurück',
      next: 'Weiter',
      showing: 'Zeigt {start} bis {end} aus {total} Ergebnissen'
    },
    importCodeEditor: {
      title: 'Import-Codes',
      addCode: 'Code hinzufügen',
      codePlaceholder: 'Import-Code eingeben',
      noCodes: 'Keine Import-Codes vorhanden',
      editCode: 'Code bearbeiten'
    }
  }
};
